import Profile from './Profile'

export default function Account() {
  return <Profile />
}
